var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitResetSecurityQuestionForm.apply(null, arguments);
      }
    }
  }, [_c('h1', {
    staticClass: "motto-blue-text mb-20"
  }, [_vm._v("Reset Security Question")]), _c('h3', {
    staticClass: "motto-blue-text mb-45"
  }, [_vm._v(_vm._s(_vm.userEmail))]), _vm.initialLoading ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : !_vm.successfully ? _c('div', [_c('BaseFormGroup', {
    staticClass: "mb-40",
    attrs: {
      "label": _vm.labels.recoveryQuestion
    }
  }, [_c('BaseSelect', {
    attrs: {
      "name": "recoveryQuestion",
      "empty-text": "-- Select a Security Question --",
      "options": _vm.recoveryQuestions,
      "option-text": "questionText",
      "option-value": "questionText"
    },
    model: {
      value: _vm.recoveryQuestion,
      callback: function callback($$v) {
        _vm.recoveryQuestion = $$v;
      },
      expression: "recoveryQuestion"
    }
  })], 1), _c('BaseFormGroup', {
    staticClass: "mb-55",
    attrs: {
      "label": _vm.labels.recoveryAnswer
    }
  }, [_c('BaseInputText', {
    attrs: {
      "autocomplete": "off",
      "name": "recoveryAnswer",
      "placeholder": _vm.placeholders.recoveryAnswer
    },
    model: {
      value: _vm.recoveryAnswer,
      callback: function callback($$v) {
        _vm.recoveryAnswer = $$v;
      },
      expression: "recoveryAnswer"
    }
  })], 1), _c('BaseButton', {
    attrs: {
      "disabled": !_vm.canPressButton,
      "type": "submit"
    }
  }, [_vm.loading ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Reset Security Question")])], 1)], 1) : _c('div', [_c('BaseLink', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('BaseButton', {
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Back to Login")])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }